import * as React from "react"
import _find from "lodash/find";

import {
    css,
    Button,
    Theme,
} from "@bdfx/mergado-ui-kit";

import {createPredefinedFIEQueries} from "app/helpers/api";
import {AxiosResponse} from "axios";
import trans from "trans";
import { FIEQueryType } from "./fie-queries";
import { PredefinedQueryType } from "./create-predefined-queries";
import { setFIEQueriesToStore } from '../reducer';

type CheckBoxType = {
    element: string
    label: string
    isChecked: boolean
    isDisabled: boolean
}

interface State {
    allPredefined: string[]
    checkboxes: CheckBoxType[]
}

interface Props {
    allPredefined: PredefinedQueryType[]
    fieQueries: FIEQueryType[]
    setFIEQueriesToStore: typeof setFIEQueriesToStore
    close: Function
}

class CreatePredefinedCheckboxes extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        const updatedCheckboxes : CheckBoxType[] = props.allPredefined.map(predefined => {
            const existingFieQuery = _find(props.fieQueries, (fieQuery) => fieQuery.element === predefined.element)
            return {element: predefined.element, label: predefined.name, isChecked: !!existingFieQuery, isDisabled: !!existingFieQuery}
        })

        this.state = {
            allPredefined: null,
            checkboxes: updatedCheckboxes,
        }
    }

    handleCreatePredefined = () => {
        const {checkboxes} = this.state

        const filtered = checkboxes.filter(checkbox => checkbox.isChecked && !checkbox.isDisabled).map(checkbox => checkbox.element)

        createPredefinedFIEQueries(filtered)
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
            .catch((error) => {
                console.error('cannot create predefined queries', error)
            })
            .finally(() => {
                this.props.close()
            })
    }

    render() {
        const {allPredefined} = this.props
        const {checkboxes} = this.state

        return (
            <StyledInputGroupV>
                {allPredefined.map(predefined => {
                    const currentCheckBox = _find(checkboxes, (checkbox) => {
                        return checkbox.element === predefined.element
                    })

                    if (currentCheckBox.isDisabled) {
                        return <div key={`checkbox_${predefined.element}`} className={'disabled'}/>
                    }

                    return <div key={`checkbox_${predefined.element}`} className={'item'}>
                        <input
                            key={`input_checkbox_${predefined.element}_${currentCheckBox.isChecked}`}
                            type={'checkbox'}
                            id={`checkbox_${predefined.element}`}
                            value={predefined.element}
                            disabled={currentCheckBox.isDisabled}
                            checked={currentCheckBox.isChecked}
                            onChange={(value) => {
                                const updatedCheckBoxes = checkboxes.map((c) => (c.element === predefined.element) ?
                                    {...c, isChecked: !currentCheckBox.isChecked} : c
                                )
                                this.setState({checkboxes: updatedCheckBoxes})
                            }}
                        />
                        <label className={currentCheckBox.isDisabled ? 'disabled' : ''} htmlFor={`checkbox_${predefined.element}`}>
                            <span className={'title'}>{currentCheckBox.label}</span> <small>({currentCheckBox.element})</small>
                        </label>
                    </div>
                })}

                <div className={'right'}>
                    <Button key='create' type="void" color={"nocolor"} onClick={(e) => this.handleCreatePredefined()}>{trans("create")}</Button>
                </div>
            </StyledInputGroupV>
        )
    }
}

const StyledInputGroupV = css('div')({
    ' label': {
        padding: '10px',
    },
    ' label.disabled': {
        textDecoration: 'line-through',
        fontSize: 'italic',
    },
    ' span.title': {
        color: Theme.steelblue,
    },
    ' small': {
        fontSize: '60%',
    },
    ' .right': {
        textAlign: 'right',
    },
    ' div.item': {
        margin: '10px',
    }
})


export default CreatePredefinedCheckboxes